interface CustomReportSettingsDerivedFlagParams {
    isReportTemplatesEnabled: boolean;
    isFlagEnabled: boolean;
}

export function resolveIsCustomReportSettingsEnabled({
    isReportTemplatesEnabled,
    isFlagEnabled,
}: CustomReportSettingsDerivedFlagParams): boolean {
    return isFlagEnabled || isReportTemplatesEnabled;
}
